<script lang="ts">
  import { sidebarOpen, paletteOpen } from "../stores";
  import ThemeToggle from "./ThemeToggle.svelte";
</script>

<header
  class="flex items-center gap-3 px-4 py-3 border-b border-border bg-bg-panel sticky top-0 z-20"
>
  <button
    class="lg:hidden text-text hover:text-accent"
    aria-label="Open menu"
    on:click={() => sidebarOpen.set(true)}
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  </button>

  <div class="text-sm font-semibold lg:hidden">Legacy Growth Playbook</div>

  <button
    class="hidden lg:flex items-center gap-2 px-3 py-1.5 rounded-pill border border-border bg-bg-raised
           text-text-muted hover:text-text hover:border-border-strong transition-colors"
    on:click={() => paletteOpen.set(true)}
    aria-label="Open search"
  >
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
      <circle cx="11" cy="11" r="7"/>
      <line x1="21" y1="21" x2="16.5" y2="16.5"/>
    </svg>
    <span class="text-xs">Search SOPs</span>
    <kbd class="ml-2 px-1.5 py-0.5 rounded bg-bg-panel border border-border text-[10px]">⌘ K</kbd>
  </button>

  <div class="flex-1"></div>

  <ThemeToggle />

  <a
    class="btn-ghost text-text-muted hover:text-text"
    href="mailto:dany@legacygrowthpartners.ie?subject=Playbook%20suggestion&body=I%20noticed%20we%27re%20missing%20an%20SOP%20for%3A%0A%0A"
  >
    + Suggest an SOP
  </a>
</header>
